import React, { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FlaskConical, X } from "lucide-react";

const PERSONAS = [["business", "Business"], ["salesman", "Salesman"], ["admin", "Admin (Owner)"]];

export default function TestModeBanner() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-test-mode", onOpen);
    return () => window.removeEventListener("open-test-mode", onOpen);
  }, []);
  if (!user || user.real_role !== "owner") return null;

  const current = user.impersonating ? user.role : "admin";
  const set = async (persona) => {
    if (busy) return;
    setBusy(true);
    try {
      await api.post("/admin/test-persona", { persona });
      window.location.href = persona === "admin" ? "/admin" : "/";
    } catch (e) { setBusy(false); }
  };

  return (
    <div className="fixed z-50 flex flex-col gap-3 top-[72px] right-3 items-end lg:top-auto lg:bottom-6 lg:left-6 lg:right-auto lg:items-start" data-testid="test-mode-control">
      {open && (
        <div className="w-64 rounded-2xl bg-yellow-400 text-slate-900 shadow-2xl shadow-yellow-400/20 p-4 animate-in fade-in slide-in-from-bottom-2 duration-200" data-testid="test-mode-panel">
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-black uppercase tracking-wider flex items-center gap-1.5"><FlaskConical className="w-4 h-4" /> Test Mode</span>
            <button onClick={() => setOpen(false)} data-testid="test-mode-close" className="p-1 rounded-full hover:bg-slate-900/10 transition-colors"><X className="w-4 h-4" /></button>
          </div>
          <p className="text-xs font-medium text-slate-800/80 mb-3">Viewing as <span className="font-bold">{current === "admin" ? "Admin (Owner)" : current}</span></p>
          <div className="flex flex-col gap-2">
            {PERSONAS.map(([p, label]) => (
              <button
                key={p}
                data-testid={`persona-${p}`}
                onClick={() => set(p)}
                disabled={busy}
                className={`text-sm font-bold px-3 py-2 rounded-xl text-left transition-colors ${current === p ? "bg-slate-900 text-yellow-400" : "bg-slate-900/10 text-slate-900 hover:bg-slate-900/20"}`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="test-mode-toggle"
        className="hidden lg:flex w-14 h-14 rounded-full bg-yellow-400 text-slate-900 shadow-xl shadow-yellow-400/30 items-center justify-center hover:scale-105 hover:bg-yellow-300 transition-all duration-200 ring-2 ring-yellow-400/40"
        title="Test Mode"
      >
        <FlaskConical className="w-6 h-6" />
      </button>
    </div>
  );
}
